import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useStatsigUser } from "@statsig/react-bindings";
import { getOrCreateStatsigStableId } from "utils/module/statsig";

const StatsigUserSync = () => {
  const authenticated = useSelector(state => state.auth.authenticated);
  const { updateUserAsync } = useStatsigUser();

  useEffect(() => {
    const stableID = getOrCreateStatsigStableId();

    if (authenticated) {
      const userId = localStorage.getItem("shop_id");
      const email = localStorage.getItem("user_email") || undefined;

      if (userId) {
        updateUserAsync({
          userID: userId,
          ...(email ? { email } : {}),
          customIDs: { stableID }
        });
      }
    } else {
      updateUserAsync({ customIDs: { stableID } });
    }
  }, [authenticated]);

  return null;
};

export default StatsigUserSync;
